import { useEffect } from 'react';

const useLatex = (text: string) => {
  useEffect(() => {
    if (window?.MathJax && window?.MathJax?.typesetClear && window?.MathJax?.typeset) {
      window.MathJax.typesetClear();
      window.MathJax.typeset();
    }
  }, [text]);
};
export default useLatex;

// Noteworthy: https://www.npmjs.com/package/better-react-mathjax
